import profile from './profile';

export default profile;
